import { Loader } from "@sicredi/react";
import { lazy, Suspense, useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { PAGE } from "#/constants";
import ProductDetails from "./containers/ProductDetails";
import ChoiceOfPlan from "./containers/ChoiceOfPlan";
import { AccountAgency } from "./containers/AccountAgency";
import { Resume } from "./containers/Resume";
import Simulation from "./containers/Simulation";
import { ContextAPI } from "./contextProver/ContextProver";
import { TrackingScreen } from "./containers/TrackingScreen";
import { BoletoAdesao } from "./containers/BoletoAdesao";
import { Contract } from "./containers/Contract";
import { PropostaAceita } from "./containers/PropostaAceita";
import { ContractDetails } from "./containers/ContractDetails";
import { MenuConsorcio } from "./containers/MenuConsorcio";
import { PAGE_INICIAL } from "./contextProver/ContextProverModel";
import { CapitalIntegralizadoModal } from "./components/AccountAgencyComponents/CapitalIntegralizadoModal";
import { FEED } from "./api/associadosFeedBackLogin";
import { CadastroErro } from "./components/AccountAgencyComponents/CadastroErro";
import { ManutencaoPage } from "./components/Pages/Manutencao";

const FAQ = lazy(() => import("#/containers/FAQ"));
const Home = lazy(() => import("#/containers/Home"));
const NotFound = lazy(() => import("#/containers/NotFound"));

function AppRoutes() {
  const {
    maintenanceData,
    homePageInitial,
    isOpenCapitalIntegralizadoModal,
    setIsOpenCapitalIntegralizadoModal,
    isOpenCadastroErroModal,
    setIsOpenCadastroErroModal,
  } = useContext(ContextAPI);

  const getPageInicial = () => {
    if (maintenanceData?.emManutencao) {
      return (
        <ManutencaoPage mensagemHorario={maintenanceData.mensagemHorario} />
      );
    }

    if (homePageInitial === PAGE_INICIAL.Home) {
      return <Home />;
    }
    if (homePageInitial === FEED.CAPITAL_INTEGRALIZADO) {
      return (
        <CapitalIntegralizadoModal
          isOpen={isOpenCapitalIntegralizadoModal}
          setIsOpen={setIsOpenCapitalIntegralizadoModal}
        />
      );
    }
    if (homePageInitial === FEED.CADASTRO_ERRO) {
      return (
        <CadastroErro
          isOpen={isOpenCadastroErroModal}
          setIsOpen={setIsOpenCadastroErroModal}
        />
      );
    }
    if (homePageInitial === null) {
      return <Loader show fullScreen />;
    }
  };

  const pageInitial = getPageInicial();

  useEffect(() => {
    getPageInicial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homePageInitial, maintenanceData]);

  if (maintenanceData === null) {
    return <Loader show fullScreen />;
  }

  if (maintenanceData.emManutencao) {
    return (
      <BrowserRouter basename={process.env.BASE_URL}>
        <ManutencaoPage mensagemHorario={maintenanceData.mensagemHorario} />
      </BrowserRouter>
    );
  }

  return (
    <Suspense fallback={<Loader show fullScreen />}>
      <BrowserRouter basename={process.env.BASE_URL}>
        <Routes>
          <Route path={PAGE.ROOT} element={pageInitial} />
          <Route path={PAGE.DETALHES_VENDA} element={<ProductDetails />} />
          <Route path={PAGE.ESCOLHA_DO_PLANO} element={<ChoiceOfPlan />} />
          <Route path={PAGE.FAQ} element={<FAQ />} />
          <Route path={PAGE.SIMULATION} element={<Simulation />} />
          <Route path="*" element={<NotFound />} />
          <Route path={PAGE.AGENCIA_CONTA} element={<AccountAgency />} />
          <Route path={PAGE.RESUME} element={<Resume />} />
          <Route path={PAGE.TRACKING} element={<TrackingScreen />} />
          <Route path={PAGE.BOLETO_ADESAO} element={<BoletoAdesao />} />
          <Route path={PAGE.CONTRATO} element={<Contract />} />
          <Route path={PAGE.PROPOSTA_ACEITA} element={<PropostaAceita />} />
          <Route path={PAGE.CONTRATO_DETALHES} element={<ContractDetails />} />
          <Route path={PAGE.MENU_CONSORCIO} element={<MenuConsorcio />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export { AppRoutes as Routes };
